import { Box, Grid } from '@mui/material';
import InputForm   from '../../InputT';
import SearInputM from '../../SearchModal';
import Params from '../../../Types/ParamsPicklist';

let searchTypAdr: Params = { CodeAgence: '', Table: "TYPADR", Colonne1: "CODTYPE", Colonne2: "LIBELL1", Colagence: '001', Choix: 22 }
let searchPays: Params = { CodeAgence: '', Table: "CDPAYS", Colonne1: "CDPAYS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchVille: Params = { CodeAgence: '', Table: "CdVille", Colonne1: "CdVille", Colonne2: "Libell", Colagence: '001', Choix: 22 }


const Tab2 = (props: { form?: any }) => {

  return (

    <div className='tabItem'>
      <div >
        <Grid container className='border' sx={{ width: "85%", position: "absolute" }}>
          <Grid item xs={12} className='border-left'>
            <Grid container>
              <Grid item xs={12} md={6} className='border-left'>
                <SearInputM width={7} disabled={true} Titre='Recherche Type Adresse' label='Type Adresse' name="TYPADR" Parametre={searchTypAdr} form={props.form} />
                <InputForm   disabled={true} notRequired width={7} label='NuméRue' name='rueCli' type='text' error=' ce Champ est obligatiore' />
                <InputForm   disabled={true} width={7} label='Numéro' RegExp={/[0-9]{9}$/gmiy} MessExp='le numéro doit étre de 9 chiffres' name='Tel2' type='number' error=' ce Champ est obligatiore' />
                <InputForm   disabled={true} notRequired width={7} label='Adresse postale' name='adrresse Postal' type='text' error=' ce Champ est obligatiore' />
                <SearInputM  disabled={true} width={7} Titre='Recherche Pays' label='Pays' name='CDERES' Parametre={searchPays} form={props.form} />
                <InputForm   disabled={true} width={7} label='Fax' name='FaxCli' type='text' error=' ce Champ est obligatiore' />
              </Grid>
              <Grid item xs={12} md={6} className='border-left'>
                <SearInputM  disabled={true} width={7} Titre='Recherche Ville' label='Ville' name='vilCli' Parametre={searchVille} form={props.form} />
                <InputForm   disabled={true} notRequired width={7} label='Telex' name='Telex' type='text' error=' ce Champ est obligatiore' />
                <InputForm   disabled={true} width={7} label='Quatier' name='nomQtier' type='text' error=' ce Champ est obligatiore' />
                <InputForm   disabled={true} width={7} label='Boite Postale' name='BpCli' type='text' />
                <InputForm   disabled={true} notRequired width={7} label='Adresse Email' name='emailctt1' type='email' error=' ce Champ est obligatiore' />
                <InputForm   disabled={true} width={7} label='Téléphone' RegExp={/[0-9]{9}$/gmiy} MessExp='le numéro doit étre de 9 chiffres' name='telCli' type='text' error=' ce Champ est obligatiore' />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>

  );

}

export default Tab2;